import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import { getPage as _getPage } from '@/api/wxmp/wxmsg';
export default {
  name: "top-mag",
  props: {},
  data: function data() {
    return {
      page: {
        total: 0,
        // 总页数
        currentPage: 1,
        // 当前页数
        pageSize: 10,
        // 每页显示多少条
        ascs: [],
        //升序字段
        descs: [] //降序字段
      },

      tableData: [],
      option: {
        size: 'mini',
        addBtn: false,
        page: false,
        menu: false,
        delBtn: false,
        editBtn: false,
        column: [{
          width: 100,
          label: '公众号',
          prop: 'appName',
          overHidden: false,
          slot: true
        }, {
          width: 60,
          label: '用户',
          prop: 'headimgUrl',
          overHidden: false,
          slot: true
        }, {
          width: 200,
          label: '内容',
          prop: 'repContent',
          overHidden: true,
          slot: true
        }, {
          width: 90,
          label: '时间',
          type: 'date',
          align: 'right',
          prop: 'createTime',
          format: 'MM-dd HH:mm'
        }]
      }
    };
  },
  created: function created() {
    if (this.permissions['wxmp:wxmsg:index']) {
      this.refreshChange();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(['permissions'])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.permissions['wxmp:wxmsg:add'] ? true : false,
        delBtn: this.permissions['wxmp:wxmsg:del'] ? true : false,
        editBtn: this.permissions['wxmp:wxmsg:edit'] ? true : false,
        viewBtn: this.permissions['wxmp:wxmsg:get'] ? true : false
      };
    }
  }),
  methods: {
    showMsg: function showMsg(row, event, column) {
      this.$emit('showMsg', {
        appId: row.appId,
        wxUserId: row.wxUserId
      });
      this.tableData.splice(row.$index, 1);
    },
    getPage: function getPage(page, params) {
      var _this = this;
      _getPage(Object.assign({
        current: page.currentPage,
        size: page.pageSize,
        descs: page.descs,
        ascs: page.ascs,
        notInRepType: 'event'
      }, params)).then(function (response) {
        _this.tableData = response.data.data.records;
        _this.page.total = response.data.data.total;
        _this.page.currentPage = page.currentPage;
        _this.page.pageSize = page.pageSize;
      });
    },
    /**
     * 刷新回调
     */
    refreshChange: function refreshChange() {
      this.page.descs = 'create_time';
      this.getPage(this.page, {
        type: '1',
        readFlag: "0"
      });
    }
  }
};